import { httpClient } from '@shared/api'
import type { LoginArgs, LoginMiniAppArgs, LoginResponse, LogoutArgs, RefreshArgs, RefreshResponse } from './types'

export const login = async (data: LoginArgs) => {
    const { data: result } = await httpClient.post<LoginResponse>('/auth/login', data, {
        withCredentials: false
    })
    return result
}

export const loginByMiniApp = async (data: LoginMiniAppArgs) => {
    const { data: result } = await httpClient.post<LoginResponse>('/auth/login/miniapp', data, {
        withCredentials: false
    })
    return result
}

export const loginAnonymous = async () => {
    const { data: result } = await httpClient.post<LoginResponse>(
        '/auth/login/anonymous',
        {},
        { withCredentials: false }
    )
    return result
}

export const logout = async (data: LogoutArgs) => {
    return httpClient.post<void>('/auth/logout', data, {
        withCredentials: false
    })
}

export const refreshTokens = async (data: RefreshArgs) => {
    const { data: result } = await httpClient.post<RefreshResponse>('/auth/refresh', data)
    return result
}
